import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=6ce219d2&scoped=true&"
import script from "./menu-bar.vue?vue&type=script&lang=js&"
export * from "./menu-bar.vue?vue&type=script&lang=js&"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=6ce219d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce219d2",
  null
  
)

export default component.exports